import React, { useState, useEffect } from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ isInitialLoad = false, onLoadComplete, targetRef }) => {
  const [isCompleting, setIsCompleting] = useState(false);
  const [targetPosition, setTargetPosition] = useState({ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' });

  useEffect(() => {
    if (isInitialLoad) {
      const timer = setTimeout(() => {
        if (targetRef.current) {
          const rect = targetRef.current.getBoundingClientRect();
          setTargetPosition({
            top: `${rect.top}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
            height: `${rect.height}px`,
            transform: 'translate(0, 0)',
          });
        }
        setIsCompleting(true);
        setTimeout(() => {
          onLoadComplete && onLoadComplete();
        }, 1000);
      }, 1800);
      
      return () => clearTimeout(timer);
    }
  }, [isInitialLoad, onLoadComplete, targetRef]);

  if (isInitialLoad) {
    const logoStyle = isCompleting ? targetPosition : {};
    return (
      <div className={`initial-loading ${isCompleting ? 'completing' : ''}`}>
        <div className="loading-background"></div>
        <div className={`loading-logo ${isCompleting ? 'move-to-top' : ''}`} style={logoStyle}>
          <img 
            src="/whatsmeme.png" 
            alt="Whatsmeme" 
            className="loading-image"
          />
          {!isCompleting && (
            <div className="loading-text">
              <h1 className="loading-title rubik-bubbles-regular">Whatsmeme</h1>
              <div className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 普通加载动画（分析时使用）
  return (
    <div className="loading-container">
      <div className="analysis-loading">
        <img 
          src="/whatsmeme.png" 
          alt="分析中" 
          className="analysis-image"
        />
        <div className="analysis-text">
          <h3>🤖 AI正在分析你的表情包</h3>
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
          <p>请稍等，精彩分析即将呈现...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;